<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-09-05 09:52:13
 * @LastEditTime : 2024-09-06 14:53:58
 * @LastEditors  : yangxr
 * @Description  : 调量管理审批
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\adjustQuantity_sign.vue
-->
<!--
 * @Description: 交工资料审批
 * @Author: wangwangwang
 * @Date: 2020-12-01 11:47:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 10:56:41
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div style="padding-top:20px;">
              <el-form :inline='true' :model="formData" label-width="120px">
                <div style="font-size: 18px;">调出信息</div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="调整类型">
                      <span>{{ formData.adjustmentTypeName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="月报生效时间">
                      <span>{{ formData.mouthReportDate }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="调量开始时间">
                      <span>{{ formData.adjustmentStartTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="调量结束时间">
                      <span>{{ formData.adjustmentEndTime }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="工程名称">
                      <span>{{ formData.outEngineeringName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="合同签订单位">
                      <span>{{ formData.signingUnit }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="税率">
                      <span>{{ formData.taxRate ? formData.taxRate * 100 + '%' : '' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
                  stripe :height="400" style="width: 100%" :data="selectTableData" tooltip-effect="dark">
                  <el-table-column label="工程名称" prop="engineeringName" align="center"></el-table-column>
                  <el-table-column label="产品信息" prop="productName" align="center"></el-table-column>
                  <el-table-column label="浇筑方式" prop="pourMethod" align="center"></el-table-column>
                  <el-table-column label="调出月报量" prop="amount" align="center"></el-table-column>
                </el-table>
                <div style="font-size: 18px;">调入信息</div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="工程名称">
                      <span>{{ formData.inEngineeringName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible"
                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                @handleBusiness="handleBusiness" @resetFlowState="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { updateStatus, queryProduct } from "@/api/smart/adjustQuantity.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '调量管理',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      selectTableData: [],
    }
  },
  methods: {
    handleBusiness() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      const params = {
        process_success: {
          url: '/icps/system/sign/intelligent/adjustQuantity/updateStatus',
          data: {
            id: data.id,
            approvalStatus: '2',
          },
          httpMethod: 'post',
        },
        process_failure: {
          url: '/icps/system/sign/intelligent/adjustQuantity/updateStatus',
          data: {
            id: data.id,
            approvalStatus: '3',
          },
          httpMethod: 'post',
        }
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    // resetFlowState(type) {
    //   UpdatePingGu({
    //     engineeringId: this.projectForm.engineeringId,
    //     statusNum: type === 1 ? 3 : 5,
    //     statusType: this.executePhase,
    //     secondaryStatus: 1,
    //   });
    //   const params = {
    //     engineeringId: this.projectForm.engineeringId,
    //     statusNum: type === 1 ? 3 : 5,
    //     statusType: this.executePhase,
    //     secondaryStatus: 1,
    //   };
    //   this.$refs.flowcontent.handleToFlow(params);
    //   this.showSendVisible = false;
    // },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      if (type === 1) {
        const params = {
          id: this.formData.id,
          approvalStatus: 1
        }
        updateStatus(params)
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'adjustQuantity_sign',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
   async initFlowsData(data) {
      this.formData = data;
      await this.getProductTable()
    },
    initFlowsData2() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.formData = data;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
    async getProductTable() {
      const res2 = await queryProduct({ outEngineeringNameId: this.formData.outEngineeringNameId, id: this.formData.id })
      if (res2.code == 1001) {
        if (res2.data) {
          this.selectTableData = res2.data
        } else {
          this.selectTableData = []
        }

      }
    },
  },
  async mounted() {
    const { query } = this.$route;

    if (query.type * 1 === 1) { // 发起流程
      await this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData('adjustQuantity_sign');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData2();
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
    await this.getProductTable()
  },
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}

.info {
  padding: 0 20px;
  background: #fff;

  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;

    .left {
      @include discen_al;
    }

    .text {
      margin-left: 60px;
    }
  }
}

.nav_title {
  @include discen_al;
  align-items: flex-end;

  >div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }

  i {
    margin-left: 5px;
  }

  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}</style>
  